//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import vuescroll from 'vuescroll'
import payPublic from '@/javascript/payPublic'

export default {
    components: {
        vuescroll
    },
    props:{
        contact:{
            type: Array
        },
        But1:{
            type: Boolean
        },
        But2:{
            type: Boolean
        },
        selectIndex:{
            type: Number
        },
        //游玩人选中值(单选)
        changeIndex:{
            type: Number
        },
        //游玩人选中值(多选)
        playIndex:{
            type: Array
        },
        count:{
            type: Number
        },
        dateList:{
            type: Array
        },
        type:{
            type: String
        }
    },
    data(){
        return{
            showRadioList: this.But1,
            showCheckList: this.But2,
            radioSelectedIndex: this.selectIndex,
            checkSelectedIndex: this.changeIndex,
            ops: {
                bar: {
                    background: '#ccc',
                    opacity: 0.6,
                    size: '4px',
                    minSize: .2
                }
            },
            playerList: this.dateList,
        }
    },
    computed:{
        selectNum(){
            return (this.count - this.playIndex.length) < 0 ? 0 : this.count - this.playIndex.length
        }
    },
    methods:{
        //选择框（预订人信息）
        selectSour(index) {
            this.radioSelectedIndex = index
        },
        //选择框（游玩人信息单选）
        checkSelect(index){
            this.checkSelectedIndex = index
            this.playerList = [this.contact[index]]
        },
        //选择框（游玩人信息多选）
        checkbox(index) {
            const _this = this
            if (_this.playIndex.includes(index)) {
                _this.playIndex.map((item,idx) => {
                    if(item == index){
                        _this.playIndex.splice(idx, 1)
                        _this.playerList.splice(idx, 1)
                    }
                })
            } else {
                _this.playIndex.push(index)
                _this.playerList.push(_this.contact[index])
            }
        },
        //确定
        enSour() {
            if (this.showRadioList && this.type === 'ticketOrder') {
                if(this.radioSelectedIndex != -1){
                    this.$emit('closeContactList',false)
                    this.showRadioList = false

                    const orderInfo = JSON.parse(localStorage.getItem("dateObj"))
                    orderInfo.bookInfo = {
                        order: this.radioSelectedIndex,
                        id: this.contact[this.radioSelectedIndex].id
                    }
                    localStorage.setItem('dateObj', JSON.stringify(orderInfo))
                    this.$emit('changeInfoList','radio',this.contact[this.radioSelectedIndex])
                    this.$parent.$children[1].changeList(orderInfo,'radio')
                }else{
                    payPublic.showPrompt(`请选择预订人`)
                }
            } else if(this.showCheckList && (this.type === 'ticketOrder' || this.type === 'hotelOrder')) {
                if(this.playerList.length > this.count){
                    if(this.type === 'ticketOrder'){
                        payPublic.showPrompt(`您最多可选择${this.count}位游玩人或者请添加购票数量`)
                    }else if(this.type === 'hotelOrder'){
                        payPublic.showPrompt(`您最多可选择${this.count}位入住人或者请添加房间数量`)
                    }
                }else{
                    this.$emit('closeContactList',false)
                    this.showCheckList = false
                    const orderInfo = JSON.parse(localStorage.getItem("dateObj"))
                    orderInfo.playPeople = this.playerList
                    orderInfo.playIndex = this.playIndex
                    localStorage.setItem('dateObj', JSON.stringify(orderInfo))
                    this.$emit('changeInfoList','check',this.playerList)
                    this.$parent.$children[2].changeList(orderInfo,'check','check')
                }
            }else if(!this.showRadioList && !this.showCheckList && (this.type === 'ticketOrder' || this.type === 'hotelOrder')){
                if(this.checkSelectedIndex !== -1){
                    this.$emit('closeContactList',false)
                    this.showRadioList = false
                    this.showCheckList = false
                    const orderInfo = JSON.parse(localStorage.getItem("dateObj"))
                    orderInfo.playPeople = this.playerList
                    orderInfo.changeIndex = this.checkSelectedIndex
                    localStorage.setItem('dateObj', JSON.stringify(orderInfo))
                    this.$emit('changeInfoList','check',this.playerList)
                    this.$parent.$children[2].changeList(orderInfo,'check','radio')
                }else{
                    if(this.type === 'ticketOrder'){
                        payPublic.showPrompt(`请选择游玩人`)
                    }else if(this.type === 'hotelOrder'){
                        payPublic.showPrompt(`请选择入住人`)
                    }
                }
            }
            if(this.type === 'scienceOrder'){
                this.$emit('closeContactList',false)
                const orderInfo = JSON.parse(localStorage.getItem("dateObj"))
                orderInfo.playPeople = this.playerList
                orderInfo.playIndex = this.playIndex
                localStorage.setItem('dateObj', JSON.stringify(orderInfo))
                this.$emit('changeInfoList','check',this.playerList)
                this.$parent.$children[3].changeList(orderInfo,'check','check')
            }
        },
        //取消
        cancel() {
            this.playerList = []
            this.showRadioList = false
            this.showCheckList = false
            this.$emit('closeContactList',false)
        },
        // 编辑
        editorPeople(item){
            let info = {}
            info = item
            this.$router.push({
                path: '/addContact',
                query: {
                    objData: JSON.stringify(info),
                    tabIndex: 1
                }
            })
        },
        //新增预订、游玩人
        addNewPerson() {
            this.$router.push({path: '/addContact'})
        },
    }
}
